/**
 * 使い方ガイド（/guide）の日本語の文言（2026-10-07 console/guide-page・en.guide.ts と同じキー）。
 * 日本語は既定で出さない（languages.ts）が、型で en と同じキーを持つ
 */
import type { enGuide } from './en.guide';

export const jaGuide: Record<keyof typeof enGuide, string> = {
  'guide.topbarLink': '使い方',
  // 「Docs」より「ドキュメント」の方が日本語の画面で読みやすい（ほかの入口も「使い方」「お金」と日本語）
  'guide.docsLink': 'ドキュメント',
  'guide.homeLink': '{product}の使い方',
  'guide.title': '{product}の使い方',
  'guide.lead': 'やりたいことはすべて、AIエージェントに頼むだけです。このページでは、始め方と頼めることを紹介します。',

  'guide.start.title': '始め方',
  'guide.start.connect.title': 'AIをつなぐ',
  'guide.start.connect.body': '下の文をコピーして、使っているAIに貼ります。使うパソコン・AIエージェント・AIのアプリごとに1回だけです。', // 2026-10-11 console/one-connect: 選ぶボタンをやめて 1 つの文に
  'guide.start.connect.link': 'AIエージェントをつなぐ',
  'guide.start.ask.title': '作りたいものを頼む',
  'guide.start.ask.body': '作りたいものを、ふだんの言葉でAIエージェントに伝えます。作りかけのアプリやゲームがあるなら、それをAIエージェントで開いて、次のように頼みます。',
  'guide.start.ask.example': 'このアプリに{product}を組み込んで、テスト用に公開して。',
  'guide.start.publish.title': '「公開して」と言う',
  'guide.start.publish.body': 'AIエージェントはまずテスト用に出して、試せるリンクを教えてくれます。よければ「公開して」と言ってください。みんなに公開する前に、{product}が1回だけ確かめます。',
  'guide.flow.test': 'テスト版。リンクを知っている人だけが開ける',
  'guide.flow.say': '「公開して」と言う',
  'guide.flow.confirm': '{product}のページで 1 回だけ確かめる',
  'guide.flow.live': 'みんなが開ける',
  'guide.flow.alt.test': 'テスト版を開いたブラウザ。Test version の札',
  'guide.flow.alt.say': '入力欄に「publish it」と打ち、送るボタンに印',
  'guide.flow.alt.confirm': '{product}の公開の確認のページ。Publish のボタンに印',
  'guide.flow.alt.live': '同じアプリを公開の住所で開いたところ。Public の札',

  'guide.can.title': '頼めること',
  'guide.can.lead': '1行をコピーしてAIエージェントに貼ると、アプリやゲームに組み込んでくれます。',
  'guide.item.multiplayer.title': 'オンライン対戦',
  'guide.item.multiplayer.body': '同じゲームを何人かでいっしょに遊べます。対戦や協力、すぐに相手を探す、部屋の番号を教え合う、など。部屋は{product}が動かします。',
  'guide.item.multiplayer.ask': 'このゲームをオンラインで対戦できるようにして。すぐに相手を探すのと、部屋の番号で入るのを付けて。',
  'guide.item.leaderboard.title': 'ランキング',
  'guide.item.leaderboard.body': 'ハイスコア、週ごとのランキング、自分の順位。AIエージェントがあなたのデータベースとサーバーの処理に作るので、コードも、スコアも、決まり（ずるを防ぐ方法など）もあなたのものです。',
  'guide.item.leaderboard.ask': '週ごとのハイスコアと自分の順位が見えるランキングを付けて。',
  'guide.item.signIn.title': 'ログイン',
  'guide.item.signIn.body': '最初はゲストとしてすぐ使えます。あとから、メールとパスワード、Google、Discord、Apple、X でログインすると、データが残ります。Google・Discord・Apple・X は、それぞれのサービスにあなたのアプリを一度登録します（やり方は AI エージェントが教えます）。',
  'guide.item.signIn.bodyAccount': '最初はゲストとしてすぐ使えます。あとから、{product}（設定なし・オンにするだけ）、メールとパスワード、Google、Discord、Apple、X でログインすると、データが残ります。Google・Discord・Apple・X は、それぞれのサービスにあなたのアプリを一度登録します（やり方は AI エージェントが教えます）。{product} のログインは登録なしで使えます。',
  'guide.item.signIn.ask': 'ログインを付けて。最初はゲストで、Googleでログインするとデータが残るように。',
  'guide.item.saves.title': 'セーブ',
  'guide.item.saves.body': '一人ひとりの進み具合や設定が保存され、どの端末でも続きから使えます。',
  'guide.item.saves.ask': '一人ひとりの進み具合を保存して、別の端末でも続きからできるようにして。',
  'guide.item.functions.title': 'サーバーの処理とデータベース',
  'guide.item.functions.body': 'みんなで共有するデータや、自分のキーが要るサービスの呼び出しなど、ブラウザだけで決めてはいけないことに使います。コードはAIエージェントが書き、{product}が動かします。',
  'guide.item.functions.ask': '使う人みんなで共有するリストを、サーバーのデータベースに保存して。',
  'guide.item.domain.title': '自分のドメイン',
  'guide.item.domain.body': '{product}のアドレスの代わりに、自分のアドレス（play.example.com など）で公開できます。ドメインは好きな所で買ってください。',
  'guide.item.domain.ask': '自分のドメイン play.example.com で公開して。',
  'guide.item.shareCard.title': 'X のカード',
  'guide.item.shareCard.body': 'だれかがリンクを X に投稿すると、画像とタイトルのカードで表示されます。',
  'guide.item.shareCard.ask': 'X にリンクが投稿されたら、画像とタイトルのカードが出るようにして。',

  // Preview の段（2026-10-16 console/guide-preview・en.guide.ts の WHY）。名前 {preview} は日本語でも英語のまま（ja.mcpAuth.ts と同じ）
  'guide.preview.title': 'Preview · {preview}',
  'guide.preview.lead': 'まだ試している新しい機能です。変わることがあります。',
  'guide.preview.model3d.title': '3Dモデルと Blender',
  'guide.preview.model3d.body': 'あなたのAIが、Tripo で 3D のキャラや物を作り（1体 約$0.20）、重いモデルを Blender で軽くして（約$0.01）、ゲームに入れられます。',
  'guide.preview.more': 'テクスチャや背景などの画像を作ったり（1枚 $0.003から）、このゲームで前に作った 3D モデルを探したりもできます。',
  'guide.preview.cost': '費用は前払いの残高から引かれます。足りないときは、作る前に止まります。',

  'guide.cost.title': '料金',
  'guide.cost.body': '使った分だけ、原価でかかります。前払いの残高から引かれます。',
  'guide.cost.balanceLink': '残高を見る',
  'guide.cost.usageLink': '使った量を見る',
  'guide.help': '困ったときは {email} にメールしてください。'
};
